/* istanbul ignore file: Excluded from coverage; this file configures Chakra UI styles, with no custom logic to test */
import { progressAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
import { colors } from '../foundations/colors';

const helpers = createMultiStyleConfigHelpers(progressAnatomy.keys);

export const Progress = helpers.defineMultiStyleConfig({
  variants: {
    blue: ({ colorMode }: { colorMode: 'dark' | 'light' }) => ({
      track: {
        width: 'inherit',
        height: '0.625rem',
        borderRadius: '0.5rem',
        backgroundColor: colors.interactive.hover[colorMode],
      },
      filledTrack: {
        // This gives it the blue color
        backgroundColor: colors.text.hyperlink[colorMode],
      },
    }),
  },
});
